import { useParams } from 'react-router'
import { useFetchQuestionsQuery } from '../../../../../store/apis/question.api'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { isNumber } from 'lodash'
import { textSubmissionDrawerActions } from '../../../../../store/slices/text-submission-drawer.slice'
import { useVersionId } from '../../../../../utils/parseURL.helper'
import { getQuestionById } from '../../../../../store/apis/utils/selectors/question.api.selectors'

const useExpandQuestionsManager = () => {
    const dispatch = useDispatch()
    const { token, layerId: questionIdParam } = useParams()
    const questionId = ['all', 'dashboard'].includes(questionIdParam) ? null : parseInt(questionIdParam)
    const versionId = useVersionId()

    const { data: questions } = useFetchQuestionsQuery({ token, versionId })

    useEffect(() => {
        if (!questions) return
        if (isNumber(questionId)) {
            const question = getQuestionById(questions, questionId)
            if (question) {
            dispatch(
                textSubmissionDrawerActions.setExpandedQuestionIds([
                    question.parentId || questionId,
                    ...question.dependsOnQuestionIds,
                ]),
            )
        } else {
                dispatch(textSubmissionDrawerActions.setExpandedQuestionIds(questions.map(q => q.id)))
            }
        }
    }, [questions, questionId])
}

export default useExpandQuestionsManager
